import React, { Component } from "react";
import { covertSecondsToTimeClock } from "../../utils/display.js";

export default class CountdownTimer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      secondsRemaining: 0,
    };
  }

  componentDidMount() {
    this.setState({ secondsRemaining: this.props.secondsRemaining });
    this.interval = setInterval(this.tick, 1000);
  }
  componentWillUnmount() {
    clearInterval(this.interval);
  }

  tick = () => {
    this.setState({ secondsRemaining: this.state.secondsRemaining - 1 });
    if (this.state.secondsRemaining <= 0) {
      clearInterval(this.interval);
      this.props.showSessionExpiredBox();
    }
  };

  render() {
    return (
      <div style={{ textAlign: "center", marginBottom: "10px" }}>
        Session expiring in{" "}
        <span className="partner-specific-color" style={{ fontWeight: "bold" }}>
          {covertSecondsToTimeClock(this.state.secondsRemaining)}
        </span>
      </div>
    );
  }
}
